import { useQuery } from "@tanstack/react-query";
import { useAuth } from "zudoku/hooks";
import { useTenantStore } from "../stores/tenantStore";

export default function useGetTenantApplications() {

  const apiAccessUrl = import.meta.env.ZUDOKU_PUBLIC_APIACCESSMANAGEMENT_FA_URL
  const subscriptionKey = import.meta.env.ZUDOKU_PUBLIC_SUBSCRIPTION_KEY
  const tenantCode = useTenantStore((state) => state.currentTenant);
  const {providerData, isAuthenticated} = useAuth();
  const token = providerData?.accessToken || providerData?.idToken;
  
  
  return useQuery({
    retry: 5,
    enabled: !!tenantCode && !!token && isAuthenticated,
    queryKey: ['GET', `${apiAccessUrl}/${tenantCode}/applications`],
    queryFn: async () => {
      const response = await fetch(`${apiAccessUrl}/${tenantCode}/applications`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Authorization": `Bearer ${token}`,
          "X-NBLY-Tenant-Code": tenantCode,
          "X-NBLY-Portal-Type": 'participant',
          "Ocp-Apim-Subscription-Key": subscriptionKey,
      },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch tenant applications');
      }

      return response.json();
    },
  });
}